"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.remove = exports.set = exports.get = void 0;
const y_cookie_1 = __importDefault(require("y-cookie"));
/* eslint-disable  */
// https://github.yandex-team.ru/performance/yc-cookie
// yc-cookie c более длинным expires для вложенных записей
const COOKIE_NAME = 'yc';
const COOKIE_EXPIRE = 2 * 7 * 24 * 60 * 60; // 2 недели
const COOKIE_PART_EXPIRE = 2 * 4 * 7 * 24 * 60 * 60; // 4 недели вместо 3 дней
/**
 * Получает значения из контейнера yc
 * @param {String} projectName lp/lr/ls/...
 * @returns {Object}
 */
const get = (projectName) => {
    var parts = parseCookieVals(), result = {}, stringifiedValue, pairs, pair;
    if (!parts[projectName]) {
        return {};
    }
    stringifiedValue = parts[projectName];
    if (stringifiedValue && stringifiedValue.value) {
        stringifiedValue = stringifiedValue.value;
    }
    pairs = stringifiedValue.split(',');
    for (var i = 0, l = pairs.length; i < l; ++i) {
        pair = pairs[i].split(':');
        result[pair[0]] = parseInt(pair[1], 10);
    }
    return result;
};
exports.get = get;
/**
 * Устанавливает значения в контейнер
 * @param {String} projectName lp/lr/ls/...
 * @param {Object} vals Простой объект вида с парами ключей и значений, без вложенности
 * @returns {ycCookie}
 */
const set = (projectName, vals) => {
    if (!projectName || !vals || typeof vals !== 'object') {
        return this;
    }
    var parts = parseCookieVals(), valsArr = [], i, l, keys;
    for (i = 0, keys = Object.keys(vals), l = keys.length; i < l; i++) {
        valsArr.push(keys[i] + ':' + vals[keys[i]]);
    }
    if (!valsArr.length) {
        return this;
    }
    parts[projectName] = {
        value: valsArr.join(','),
        expires: String(Math.floor(Date.now() / 1000 + COOKIE_PART_EXPIRE))
    };
    setCookieVals(parts);
    return this;
};
exports.set = set;
/**
 * Удаляет элемент из контейнера
 * @param {String} projectName lp/lr/ls/...
 * @returns {ycCookie}
 */
const remove = (projectName) => {
    if (!projectName) {
        return this;
    }
    var parts = parseCookieVals();
    delete parts[projectName];
    setCookieVals(parts);
    return this;
};
exports.remove = remove;
/**
 * Возвращает распарсенную куку yc документа в виде {lr: {value: '...', expires: ...}, ls: '...'} или пустой объект
 * @returns {Object}
 */
function parseCookieVals() {
    var parts = document.cookie.split('; '), vals, items;
    for (var i = 0; i < parts.length; ++i) {
        vals = parts[i].split('=');
        // yc=<...>#EXPIRE.lp.1038:2153,1040:13624,1385:6#<...>
        if (vals[0] === COOKIE_NAME) {
            items = y_cookie_1.default.parse(vals.slice(1).join('='));
            return items || {};
        }
    }
    return {};
}
/**
 * Устанавливает значения куки yc
 * @param {Object} parts
 */
function setCookieVals(parts) {
    var cookieString = y_cookie_1.default.stringify(parts), date = new Date(), now = date.getTime(), expires, domain, path;
    if (cookieString) {
        date.setTime(now + COOKIE_EXPIRE * 1000);
    }
    else {
        date.setTime(now - 487);
    }
    expires = 'expires=' + date.toUTCString();
    domain = 'domain=' + document.domain.replace(/^\S*yandex/, '.yandex');
    path = 'path=/';
    document.cookie =
        COOKIE_NAME + '=' + cookieString + '; ' + expires + '; ' + domain + '; ' + path;
}
